import React from "react";
import ReactDOM from "react-dom";
import Header from './header';
import "./index.css";


const headerElement = document.getElementById("header");
ReactDOM.render(<Header />, headerElement);
